import React from "react";
import "./index.css";
import { Box } from "@chakra-ui/react";
export default function CasinoVideoRules({
  id,
  custom,
  image = "https://sitethemedata.com/v3/static/front/img/casino-rules/dt202.jpg",
}) {
  const [show, setShow] = React.useState(false);
  return (
    <Box className="casino-options">
      <div className="casino-video-right-icons">
        <div title="Home" className="casino-video-home-icon">
          <a
            href="/live-casino"
            className="router-link-active"
            style={{ color: "var(--text-highlight)" }}
          >
            <i className="fas fa-home" />
          </a>
        </div>{" "}
        <div
          onClick={() => setShow(!show)}
          title="Rules"
          className="casino-video-rules-icon"
        >
          <i className="fas fa-info-circle" />
        </div>{" "}
        {/**/}
      </div>
      {show && (
        <div
          id="casino-video-rules"
          aria-modal="true"
          className={`casino-vieo-rules ${
            show ? "show" : "hide"
          } d-none-small show-rules snipcss-ittBn style-IJ9dB`}
        >
          <div className="rules-header">
            <div>Rules</div>
            <div onClick={() => setShow(false)}>
              <i className="fas fa-times"></i>
            </div>
          </div>

          <div className="rules-body">
            <div>
              <style
                type="text/css"
                dangerouslySetInnerHTML={{
                  __html:
                    '\n        .rules-section .row.row5 {\n          margin-left: -5px;\n          margin-right: -5px;\n        }\n        .rules-section .pl-2 {\n          padding-left: .5rem !important;\n        }\n        .rules-section .pr-2 {\n          padding-right: .5rem !important;\n        }\n        .rules-section .row.row5 > [class*="col-"], .rules-section .row.row5 > [class*="col"] {\n          padding-left: 5px;\n          padding-right: 5px;\n        }\n        .rules-section\n        {\n          text-align: left;\n          margin-bottom: 10px;\n        }\n        .rules-section .table\n        {\n          color: #fff;\n          border:1px solid #444;\n          background-color: #222;\n          font-size: 12px;\n        }\n        .rules-section .table td, .rules-section .table th\n        {\n          border-bottom: 1px solid #444;\n        }\n        .rules-section ul li, .rules-section p\n        {\n          margin-bottom: 5px;\n        }\n        .rules-section::-webkit-scrollbar {\n          width: 8px;\n        }\n        .rules-section::-webkit-scrollbar-track {\n          background: #666666;\n        }\n        .rules-section::-webkit-scrollbar-thumb {\n          background-color: #333333;\n        }\n        .rules-section .rules-highlight\n        {\n          color: #FDCF13;\n          font-size: 16px;\n        }\n        .rules-section .rules-sub-highlight {\n          color: #FDCF13;\n          font-size: 14px;\n        }\n        .rules-section .list-style, .rules-section .list-style li\n        {\n          list-style: disc;\n        }\n        .rules-section .rule-card\n        {\n          height: 20px;\n          margin-left: 5px;\n        }\n        .rules-section .card-character\n        {\n          font-family: Card Characters;\n        }\n        .rules-section .red-card\n        {\n          color: red;\n        }\n        .rules-section .black-card\n        {\n          color: black;\n        }\n        .rules-section .cards-box\n        {\n          background: #fff;\n          padding: 6px;\n          display: inline-block;\n          color: #000;\n          min-width: 150px;\n        }\n      ',
                }}
              />
              {custom ? (
                custom
              ) : (
                <div className="rules-section">
                  <div>
                    <img src={image} className="img-fluid" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Box>
  );
}
